<template>
  <div>
    <div class="container mx-auto flex flex-wrap py-10">
      <div v-for="strip in strips" :key="strip.img" class="p-3 w-auto sm:w-2/3 mx-auto md:w-1/3">
        <div class="bg-white shadow rounded-lg hover:shadow-lg">
          <a :href="strip.img" target="_blank">
            <img class="w-full h-full object-cover rounded-lg opacity-90 hover:opacity-100 p-2" :src="strip.min">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    strips() {
      return this.$store.state.strips;
    },
  },
}
</script>
